/**
 *
 * @module atvFairPlayCertificateStorage
 *
 */

import Check from 'check-types';

import FairPlayCertificateStorage from './fairPlayCertificateStorage';

/**
 *
 * @class AtvFairPlayCertificateStorage
 * @extends {FairPlayCertificateStorage}
 * @desc Provides a storage mechanism for storing a Fairplay Certificate.
 * @since 3.3.3
 *
 */
export default class AtvFairPlayCertificateStorage extends FairPlayCertificateStorage {

    /**
     *
     * @param {Sring} clientId
     * @param {String} environment
     * @param {SDK.Services.Storage} storage
     * @param {SDK.Logging.Logger} logger
     *
     */
    constructor(clientId, environment, storage, logger) {

        super(clientId, environment, storage, logger);

        this.logger.log(AtvFairPlayCertificateStorage.name, 'Created.');

    }

    /**
     *
     * @access private
     * @desc gets the stored certificate if found
     * @returns {Promise<String|Undefined>}
     *
     */
    getStoredCertificate() {

        const { cacheKey, storage } = this;

        return storage.get(cacheKey).then((storedCertificate) => {

            let certificate;

            if (Check.nonEmptyString(storedCertificate)) {
                certificate = storedCertificate;
            }

            return Promise.resolve(certificate);

        });

    }

    /**
     *
     * @access private
     * @param {String} certificate
     * @desc attempts to store a certificate via the Storage API
     * @returns {Promise<Void>}
     *
     */
    storeCertificate(certificate) {

        const { cacheKey, storage } = this;

        return storage.set(cacheKey, certificate);

    }

}



// WEBPACK FOOTER //
// ./src/drm/atvFairPlayCertificateStorage.js